module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-icons/refinance.svg?95a25a17b0f406b51ce18b0b3a657fb6";